"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@material-ui/core");
var _DisplayBodyCell = _interopRequireDefault(require("./DisplayBodyCell"));
var _DefaultThemConfig = _interopRequireDefault(require("./DefaultThemConfig"));
var _Types = require("../util/Types");
var _ActionBodyCell = _interopRequireDefault(require("./ActionBodyCell"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
/**
* 1. Returns cell associated with action (checkbox / delete view)
* 2. Returns cell associated with display data (DisplayBodyCell)
*/
var CustomTableBody = function CustomTableBody(_ref) {
  var _ref$rows = _ref.rows,
    rows = _ref$rows === void 0 ? [] : _ref$rows,
    table = _ref.table,
    onRowSelectChange = _ref.onRowSelectChange,
    _ref$customTheme = _ref.customTheme,
    customTheme = _ref$customTheme === void 0 ? {} : _ref$customTheme;
  var columns = table.columns;
  var displayColunms = columns.filter(function (col) {
    return col.display;
  });
  var themeConfig = (0, _core.createTheme)({
    overrides: _objectSpread(_objectSpread({}, (0, _DefaultThemConfig.default)()), customTheme)
  });
  return /*#__PURE__*/_react.default.createElement(_core.ThemeProvider, {
    theme: themeConfig
  }, /*#__PURE__*/_react.default.createElement(_core.TableBody, null, rows.map(function (row) {
    return /*#__PURE__*/_react.default.createElement(_core.TableRow, null, displayColunms.map(function (column) {
      var cellType = column.cellType;
      var isActionCell = _Types.actionCellTypes.includes(cellType) || false;
      if (isActionCell) {
        return /*#__PURE__*/_react.default.createElement(_ActionBodyCell.default, {
          row: row,
          column: column,
          onRowSelectChange: onRowSelectChange
        });
      }
      return /*#__PURE__*/_react.default.createElement(_DisplayBodyCell.default, {
        column: column,
        row: row
      });
    }));
  })));
};
CustomTableBody.propTypes = {
  table: _propTypes.default.objectOf(_propTypes.default.object).isRequired,
  rows: _propTypes.default.arrayOf(_propTypes.default.object).isRequired,
  onRowSelectChange: _propTypes.default.func.isRequired
};
var _default = CustomTableBody;
exports.default = _default;